import { Component, OnInit } from '@angular/core';
import { Edition } from '../../models/edition.model';
import { EditionService } from '../../services/edition.service';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-gestion-archives',
  templateUrl: './gestion-archives.component.html',
  styleUrls: ['../gestion-evenements/gestion-evenements.component.css']
})
export class GestionArchivesComponent implements OnInit {

  editions: Edition[] = [];
  formEdition: Edition = this.formVide();
  idEnModification: number | null = null;
  messageConfirmation = '';

  constructor(
    private editionService: EditionService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    this.chargerEditions();
  }

  chargerEditions(): void {
    this.editionService.getEditions().subscribe(data => {
      this.editions = data;
    });
  }

  formVide(): Edition {
    return { annee: new Date().getFullYear(), theme: '', nbSpectacles: 0, nbSpectateurs: 0, photoUrl: '' };
  }

  validerFormulaire(): void {
    if (this.idEnModification !== null) {
      this.editionService.updateEdition(this.idEnModification, this.formEdition).subscribe(() => {
        this.messageConfirmation = 'Édition modifiée avec succès !';
        this.journalService.ajouter(`Édition ${this.formEdition.annee} modifiée.`).subscribe();
        this.annulerModification();
        this.chargerEditions();
        setTimeout(() => this.messageConfirmation = '', 3000);
      });
    } else {
      this.editionService.createEdition(this.formEdition).subscribe(() => {
        this.messageConfirmation = 'Édition ajoutée avec succès !';
        this.journalService.ajouter(`Édition ${this.formEdition.annee} ajoutée.`).subscribe();
        this.formEdition = this.formVide();
        this.chargerEditions();
        setTimeout(() => this.messageConfirmation = '', 3000);
      });
    }
  }

  modifierEdition(edition: Edition): void {
    this.idEnModification = edition.id !== undefined ? edition.id : null;
    this.formEdition = { ...edition };
  }

  annulerModification(): void {
    this.idEnModification = null;
    this.formEdition = this.formVide();
  }

  supprimerEdition(edition: Edition): void {
    if (edition.id === undefined) return;

    if (confirm('Supprimer cette édition ?')) {
      this.editionService.deleteEdition(edition.id).subscribe(() => {
        this.journalService.ajouter(`Édition ${edition.annee} supprimée.`).subscribe();
        this.chargerEditions();
      });
    }
  }
}
